module.exports = {"VIEWABLE_VIDEO_VIEW":{"PERCENT_VIEWABLE":50,"DURATION":2000}}


//////////////////
// WEBPACK FOOTER
// ./src/Services/Measurement/ViewableCriteria.json
// module id = 148
// module chunks = 6